// const url = 'http://localhost:3001/api/v1'
import authAxios from 'utils/authAxios';

export const getStaticChartData = () => {
  return authAxios.post(`api/v1/getSaticChartData`);
};

export const getStaticBCBVData = (body) => {
  return authAxios.get(`api/v1/getSaticBCBVData`, body);
};

export const npiDistributionAcrossCountry = (body) => {
  return authAxios.post(`api/v1/npi_dist_across_Ccountry`, body);
};

export const getdDrgByHospitalCountWithNtype = (body) => {
  return authAxios.post(`api/v1/getdDrgByHospitalCountWithNtype`, body);
};

/*  Get procedure audit report*/
export const getHospitalCountDrg = (type) => {
  return authAxios.get(`api/v1/getHospitalCountDrg?data_type=${type}`);
};

export const getDistingDRGByNegotiations = (type) => {
  return authAxios.get(`api/v1/getDistingDRGByNegotiations?data_type=${type}`);
};

export const getProviderDrgByHospital = (body) => {
  return authAxios.post(`api/v1/getProviderDrgByHospital`, body);
};

export const getstateDrgByHospital = (body) => {
  return authAxios.post(`api/v1/getstateDrgByHospital`, body);
};

/*  Get procedure by hsopital */

export const getPCHcodeType = (body) => {
  return authAxios.post(`api/v1/getPCHcodeType`, body);
};

export const getPCHnegotiatedType = (body) => {
  return authAxios.post(`api/v1/getPCHnegotiated`, body);
};

export const getPCHl1description = (body) => {
  return authAxios.post(`api/v1/getPCHl1description`, body);
};

export const getPCHreportingEntity = (body) => {
  return authAxios.post(`api/v1/getPCHreportingEntity`, body);
};

export const getPCHcity = (body) => {
  return authAxios.post(`api/v1/getPCHcity`, body);
};

export const getPCHbillingCodeModifiers = (body) => {
  return authAxios.post(`api/v1/getPCHbillingCodeModifiers`, body);
};

export const getProcedureCostByHospital = (body) => {
  return authAxios.post(`api/v1/getProcedureCostByHospital`, body);
};

export const getDrgReferenceTable = (state) => {
  return authAxios.post(`api/v1/getDrgReferenceTable`, state);
};
